export default {"src":"/_next/static/media/form-error.adb6f308.svg","height":424,"width":658};